module.exports = __webpack_public_path__ + "static/img/icons-04.90e45e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons-04.png
// module id = 1413
// module chunks = 4